import moment from "moment";
import { Restaurant, RestaurantCart } from "../../../../../interfaces/Catalogue";
import { findCurrentShift } from "../../../../../utils/shopSubtittleFormat";
import { getOrderTypeText } from "../../../../../constants/constants";
import "./CartHeader.scss"
interface CartHeaderProps {
  restaurantCart: RestaurantCart;
  restaurant:Restaurant;
}

export default function CartHeader(props: CartHeaderProps) {
  const {restaurant, restaurantCart } = props;
  const currentShift = findCurrentShift(restaurant);
  const orderTypeText = getOrderTypeText(restaurantCart?.mode);

  return (
    <div className="CartHeader">
      {props?.restaurantCart?.categories?.length === 0 ? (
        "No restaurantCart"
      ) : (
        <div>
          <div className="wrapper">
            <p className="restaurantName">
              {restaurant?.nom}
            </p>
            <p className="restaurant-status">
            {currentShift?.isCurrentShift ? "Fermé" : "Ouvre"} à{" "}
              {currentShift?.isCurrentShift
                ? moment(currentShift?.close, "HH:mm").format("HH:mm")
                : moment(currentShift?.open, "HH:mm").format("HH:mm")}{" "}
              •
            </p>
            <div className="col-wrapper">
              <p className="restaurantAdresse">
                {orderTypeText} :
                {restaurant?.address}
              </p>
              <p className="articlesSlot">
                {restaurantCart?.categories?.length} article
                {restaurantCart?.categories?.length > 1 ? "(s)" : ""}
              </p>
            </div>
          </div>
          <div className="seperator-cart"></div>
        </div>
      )}
    </div>
  );
}
